{
  "longPressMessage": "Long press or press Alt + ArrowDown to open menu"
}
